export default __webpack_public_path__ + "static/media/flutter.64a5860f.webp";